import instance from "../utils/api_instance.util";
import { PACK_WRITE_TIMEOUT_MS } from "../utils/packApi.util.js";

export const fetchQuestPackListAPI = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-challenge/fetchList", { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};

export const createQuestPackAPI = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-challenge/create", { ...payload }, { timeout: PACK_WRITE_TIMEOUT_MS });
        return data;
    } catch (err) {
        throw err;
    }
};

export const updateQuestPackAPI = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-challenge/update", { ...payload }, { timeout: PACK_WRITE_TIMEOUT_MS });
        return data;
    } catch (err) {
        throw err;
    }
};

export const updateQuestPackItemPositionsAPI = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-challenge/updateItemPositions", { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};

export const changeQuestPackStatusAPI = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-challenge/changeStatus", { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};

export const deleteQuestPackAPI = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-challenge/delete", { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};


export const questPackDetailsById = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-challenge/fetchById", { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};

export const fetchQuestPackPurchaseStatsAPI = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-challenge/purchaseStats", { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};

export const fetchQuestPackPurchaseHistoryAPI = async (payload) => {
    try {
        const { data } = await instance.post("/api/v1/mst-challenge/purchaseHistory", { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
};

export const bulkUploadTemplateQuestPackAPI = async () => {
    try {
        const response = await instance.post(
            "/api/v1/mst-challenge/bulkUploadTemplate",
            {},
            { responseType: "blob" },
        );
        return response.data;
    } catch (err) {
        throw err;
    }
};

export const bulkUploadQuestPackAPI = async (formData) => {
    try {
        const { data } = await instance.post("/api/v1/mst-challenge/bulkUpload", formData);
        return data;
    } catch (err) {
        throw err;
    }
};
